import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

type Props = SvgIconProps;

const FormPaperIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon viewBox="0 0 20 20" {...props}>
      <path
        d="M18.3333 20.1668H3.66667C3.42355 20.1668 3.19039 20.0703 3.01849 19.8983C2.84658 19.7264 2.75 19.4933 2.75 19.2502V2.75016C2.75 2.50705 2.84658 2.27389 3.01849 2.10198C3.19039 1.93007 3.42355 1.8335 3.66667 1.8335H18.3333C18.5764 1.8335 18.8096 1.93007 18.9815 2.10198C19.1534 2.27389 19.25 2.50705 19.25 2.75016V19.2502C19.25 19.4933 19.1534 19.7264 18.9815 19.8983C18.8096 20.0703 18.5764 20.1668 18.3333 20.1668ZM7.33333 6.41683V8.25016H14.6667V6.41683H7.33333ZM7.33333 10.0835V11.9168H14.6667V10.0835H7.33333ZM7.33333 13.7502V15.5835H14.6667V13.7502H7.33333Z"
        fill={colors.gray}
      />
    </SvgIcon>
  );
};

export default FormPaperIcon;
